
import { useEffect, useState } from 'react';
import styles from './PdfPasswordProtection.module.scss';
import { RiErrorWarningFill as ErrorIcon } from 'react-icons/ri';
import { BiShow as ShowIcon, BiHide as HideIcon } from 'react-icons/bi'
import MeritoButton from '../../../../components/common/MeritoButtons/MeritoButtons';
import API from '../../../../rest/api';
import { checkPDFProtection } from '../utils/functions';
import { pdfProtectionStates } from '../../../../interfaces/interfaces';
import { HiCheckCircle as ConfirmIcon } from 'react-icons/hi'

type Props = {
    handleSubmitPassword: (password: string) => void;
    fileDetails: any;
    showPasswordSuccess: boolean;
    compact?: boolean;
}

const PdfPasswordProtection = ({ fileDetails, handleSubmitPassword, showPasswordSuccess, compact }: Props) => {
    const [showPassword, setShowPassword] = useState(false);
    const [password, setPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [selectedFile, setSelectedFile] = useState<File>(null);
    const [error, setError] = useState(null);


    useEffect(() => {
        if (!selectedFile) {
            if (fileDetails?.selectedFile instanceof File) {
                setSelectedFile(fileDetails.selectedFile);
            } else {
                fetchFileFromS3(fileDetails?.uploadedFile?.fileKey);
            }
        }
    }, [fileDetails]);

    const fetchFileFromS3 = async (fileKey) => {
        try {
            // setIsFetching(true);
            console.log('file key', fileKey);
            const response = await API.post('/underwriting/uploadjob/fetchfile', {
                fileKey,
            }, {
                responseType: "blob"
            });
            const contentDisposition = response.headers['content-disposition'];
            const fileName = contentDisposition
                ? contentDisposition.split("filename=")[1]?.replace(/['"]/g, "") // Extract filename
                : "downloaded-file.pdf"; // Default name

            // Convert Blob to File
            const fileObject = new File([response.data], fileName, { type: response.data.type });
            setSelectedFile(fileObject);
        } catch (error) {
            console.log('error', error);
        }
    }


    const handleSubmit = async () => {
        // check if password matches
        const isPdfProtected = await checkPDFProtection(selectedFile, password);
        console.log('isPdfProtected', isPdfProtected);
        if (isPdfProtected == pdfProtectionStates.passwordValidationFailed) {
            setError('Password is incorrect. Please try again.');
        } else if (isPdfProtected == pdfProtectionStates.passwordValidated) {
            // submit password 
            setError(null);
            handleSubmitPassword(password);
        }
    }

    return (
        <div className={`${styles.rootContainer} ${showPasswordSuccess ? styles.successRootContainer : ''} ${compact ? styles.compactRootContainer : ''}`}>
            {showPasswordSuccess ?
                <div className={styles.successContainer}>
                    <div className={styles.iconContainer}>
                        <ConfirmIcon />
                    </div>
                    <div className={styles.successText}>
                        Password verified.
                    </div>
                </div>
                :
                <div className={styles.passwordRootContainer}>
                    <div className={styles.passwordContainer}>
                        <div className={styles.topContainer}>
                            <div className={styles.iconContainer}>
                                <ErrorIcon />
                            </div>
                            <div className={styles.labelContainer}>
                                {compact
                                    ? 'This file is password protected. Enter password.'
                                    : 'This document is password-protected. Enter the password to continue.'}
                            </div>
                        </div>
                        <div className={styles.inputRootContainer}>
                            <div className={`${styles.inputContainer} ${error ? styles.invalid : ''}`}>
                                <input
                                    autoComplete='new-password'
                                    className={styles.passwordField}
                                    type={showPassword ? "text" : "password"}
                                    placeholder='Enter password'
                                    onChange={(e) => setPassword(e.target.value)}
                                    value={password}
                                    onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
                                />
                                <div className={styles.iconContainer} onClick={() => setShowPassword(!showPassword)}>
                                    {showPassword ? <HideIcon /> : <ShowIcon />}
                                </div>
                            </div>
                            <div className={styles.btnContainer}>
                                <MeritoButton
                                    btnType='button'
                                    type='primary-1'
                                    size={compact ? 'md' : undefined}
                                    extraStyles={compact ? { width: '100%' } : undefined}
                                    onClick={() => {
                                        handleSubmit();
                                    }}
                                    btnText='Submit'
                                />
                            </div>
                        </div>
                    </div>
                    {error && <div className={styles.errorContainer}>{error}</div>}
                </div>}
        </div>
    );
}

export default PdfPasswordProtection;